import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';  // To get the supplier receipt ID from URL
import { db } from '../firebase-config';  // Import Firestore config
import { doc, getDoc } from 'firebase/firestore';  // Import Firestore functions
import '../css/ViewSupplierReceipt.css';  // Optional: Add some styles
import { useNavigate } from 'react-router-dom';
import LoadingSpinner from '../assets/LoadingSpinner';

const ViewSupplierReceipt = () => {
  const navigate = useNavigate();
  const { id } = useParams();  // Get the supplier receipt ID from the URL
  const [receipt, setReceipt] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSupplierReceiptDetails = async () => {
      try {
        const receiptRef = doc(db, 'supplierReceipts', id);  // Reference to the Firestore document
        const receiptDoc = await getDoc(receiptRef);

        if (receiptDoc.exists()) {
          setReceipt(receiptDoc.data());  // Set the receipt data to state
        } else {
          setError('Receipt not found.');
        }
        setLoading(false);
      } catch (err) {
        setError('Error fetching receipt details.');
        console.error(err);
        setLoading(false);
      }
    };

    fetchSupplierReceiptDetails();  // Call the function to fetch the receipt details
  }, [id]);  // Re-run the effect when the `id` changes (e.g., different receipt ID)

  // Loading and error states
  if (loading) return <LoadingSpinner isVisible={true} />;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="supplier-receipt-details-container">
      <h1 className="header-viewsupplier">Supplier Receipt Details</h1>
      <div className="supplier-receipt-details">
        <p><strong>Supplier Name:</strong> {receipt.supplierName}</p>
        <p><strong>Supplier Code:</strong> {receipt.supplierCode}</p>
        <p><strong>Date:</strong> {new Date(receipt.date).toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
          })}</p>
        <h3>Ingredients:</h3>
        <ul className="ul-viewsupplier">
          {Array.isArray(receipt.items) ? (
            receipt.items.map((item, index) => (
              <li key={index} className="li-viewsupplier">
                {item.item} - {item.quantity} {item.measurement} - - - - - - PHP {item.totalItemPrice}
              </li>
            ))
          ) : (
            <li>No ingredients available</li>
          )}
        </ul>

        <h3>Products:</h3>
        <ul className="ul-viewsupplier">
          {Array.isArray(receipt.products) ? (
            receipt.products.map((product, index) => (
              <li key={index} className="li-viewsupplier">
                {product.item} - {product.quantity} {product.measurement} - - - - - - PHP {product.totalProductPrice}
              </li>
            ))
          ) : (
            <li>No products available</li>
          )}
        </ul>
        <p><strong>Subtotal:</strong> ₱{receipt.subtotal || '0'}</p>
        <p><strong>Shipping Fee:</strong> ₱{receipt.shippingFee || '0'}</p>
        <p><strong>Total Amount:</strong> ₱{receipt.totalAmount || '0'}</p>
      </div>
      <button className="cancel-btn-supplierhistory" onClick={() => navigate('/pages/SuppliersHistory')}>
        Done
      </button>
    </div>
  );
};

export default ViewSupplierReceipt;